<template>
  <div class="portlet light">
    <div class="module-name">ASSINGMENT</div>
    <vue-spinner v-if="getLoading"></vue-spinner>
    <div class="portlet-body" v-else>
      <div class="general-item-list min110">
        <div class="item">
          <div class="item-body">Program Start Date: {{ programStartDate | formatDateModalNoTimeZone }}</div>
          <div class="item-body">Program Status: {{ programStatus }}</div>
          <div class="item-body">Case Manager: {{ caseManager }}</div>
          <div class="item-body" v-if="secondaryCaseManager && secondaryCaseManager.trim() != ''">Secondary Case Manager: {{ secondaryCaseManager }}</div>
          <div class="item-body"></div>
        </div>
      </div>
      <div class="btn-arrow-link pull-right">
        <router-link :to="{ name: 'Participant Assignment', params: { id: ($route.params.id != null) ? $route.params.id : '97' } }" tag="a" class="text-warning">
          VIEW|EDIT <i class="icon-arrow-right black"></i>
        </router-link>
        <router-link :to="{ name: 'Participant Assignment', params: { id: ($route.params.id != null) ? $route.params.id : '97' } }" tag="a" v-if="(getParticipant.assignment != null && getParticipant.assignment.length == 0) && getUser.access > 2" class="text-warning">
          NEW <em class="fa fa-angle-down"></em>
        </router-link>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Spinner from '@/components/Spinner';
  export default {
    components: {
      'vue-spinner': Spinner
    },
    computed: {
      ...mapGetters([
        'getParticipant', 'getLoading', 'getUser'
      ]),
      programStartDate() {
        if(this.getParticipant['assignment'].length != 0)
          return this.getParticipant['assignment']['program_status_start_date'];
        if(this.getParticipant['assignments'].length != 0)
          return this.getParticipant['assignments'][0]['programStatusStartDate']['date'];
        return ''
      },
      programStatus() {
        return this.getParticipant.status_label;
      },
      caseManager(){
        if(this.getParticipant['assignment'].length != 0)
          return this.getParticipant['assignment']['primary_case_manager_id'];
        if(this.getParticipant['assignments'].length != 0)
          return this.getParticipant['assignments'][0]['primaryCaseManager'];
        return ''
      },
      secondaryCaseManager(){
        if(this.getParticipant['assignment'].length != 0)
          return this.getParticipant['assignment']['secondary_case_manager_id'];
        if(this.getParticipant['assignments'].length != 0)
          return this.getParticipant['assignments'][0]['secondaryCaseManager'];
        return ''
      }
    }
  }
</script>
<style scoped>
  .min110 {
    min-height: 110px;
  }
  .black {
    color: black;
  }
  .general-item-list .item-body {
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// Assingment.vue?e91d9402